import { Navigate } from 'react-router-dom';
import { loadState } from 'src/lib/utils';
import { LOCAL_STORAGE_KEYS } from 'src/lib/constants';

export const ProtectedRoute = ({ children}) => {

  const token = loadState(LOCAL_STORAGE_KEYS.token);

  if (!token) {
    return <Navigate to="/auth/login" />;
  }

  return children;
};
